import { Phone, Clock } from "lucide-react";
import { hotlines, openingHours } from "@/lib/siteConfig";
import { SocialBar } from "@/components/SocialBar";

export const TopBar = () => {
  return (
    <div className="hidden lg:block border-b border-[#D5DEE8] bg-[#F1F4F8] text-[#193D6D]">
      <div className="az-container flex items-center justify-between gap-4 py-1">
        <div className="flex items-center gap-4">
          {hotlines.map((h) => (
            <a
              key={h.id}
              href={`tel:${h.tel}`}
              data-testid={h.testid}
              className="group flex items-center gap-2"
            >
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-white text-[var(--az-icon-default)] shadow-[0_2px_8px_rgba(25, 61, 109,0.06)] transition-colors duration-200 group-hover:bg-[var(--az-icon-hover)] group-hover:text-white">
                <Phone size={12} />
              </span>

              <span className="flex flex-col leading-tight">
                <span className="text-[0.62rem] uppercase tracking-[0.11em] text-[#6e7683]">
                  {h.label}
                </span>
                <span className="text-xs font-semibold text-[#193D6D] transition-colors duration-200 group-hover:text-[#7A1516]">
                  {h.number}
                </span>
              </span>
            </a>
          ))}
        </div>

        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2" data-testid="topbar-opening-hours-text">
            <span className="flex h-6 w-6 items-center justify-center rounded-full bg-white text-[#7A1516] shadow-[0_2px_8px_rgba(25, 61, 109,0.06)]">
              <Clock size={12} />
            </span>

            <div className="flex items-center gap-3">
              {openingHours.map((o) => (
                <span key={o.days} className="flex flex-col leading-tight">
                  <span className="text-[0.62rem] uppercase tracking-[0.11em] text-[#6e7683]">
                    {o.days}
                  </span>
                  <span className="text-xs font-semibold text-[#193D6D]">
                    {o.time}
                  </span>
                </span>
              ))}
            </div>
          </div>

          <span className="h-6 w-px bg-[#D5DEE8]" aria-hidden="true" />

          <SocialBar size="sm" testidPrefix="header-social" variant="header" />
        </div>
      </div>
    </div>
  );
};